module.exports = __webpack_public_path__ + "img/page_image_2_1.6ae53b4c.svg";